import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { Template } from '@/components/common/Template'
import { readFileSync } from 'fs'
import { join } from 'path'
import { css } from '@emotion/react'
import { colors, mq } from 'plume-ui'
import { DefaultHead } from '@/components/common/Head'
import { ExtModulesMarkdown } from '@/components/pages/extModules/extModulesMarkdown'

type MarkdownProps = {
  value: string
}

export const getStaticProps: GetStaticProps<{
  markdown: MarkdownProps
}> = async () => {
  const markdownPath = join(
    process.cwd(),
    'public',
    'static',
    'extModules',
    'text.md'
  )
  const markdownText = readFileSync(markdownPath, 'utf8')
  return { props: { markdown: { value: markdownText } } }
}

function ExtModules({
  markdown,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Template>
      <DefaultHead title="利用者に関する情報の外部送信について - スピーダ スタートアップ情報リサーチ" />
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 40px 40px 24px;
          background: ${colors.gray30};
          height: 200px;
          ${mq.untilMedium} {
            height: 128px;
            padding: 24px 24px 16px;
          }
        `}
      >
        <div>
          <h1
            css={css`
              font-size: 42px;
              text-align: center;
              line-height: 1.5;
              margin: 0 0 8px 0;
              letter-spacing: 0.01em;
              ${mq.untilMedium} {
                font-size: 24px;
              }
            `}
            data-testid="ext-modules-title"
          >
            利用者に関する情報の外部送信について
          </h1>
        </div>
      </div>
      <div
        css={css`
          display: flex;
          justify-content: center;
        `}
      >
        <div
          css={css`
            padding: 0 0 40px 0;
            max-width: 928px;
            ${mq.untilMedium} {
              padding: 0 24px 40px;
            }
          `}
        >
          <ExtModulesMarkdown>{markdown.value}</ExtModulesMarkdown>
        </div>
      </div>
    </Template>
  )
}

export default ExtModules
